export default __webpack_public_path__ + "static/media/head_3_male.ef943254.png";